export default __webpack_public_path__ + "static/media/bug.a6f6f190.svg";